// setLiveStreamPanel.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

const selectPath = ['liveStream', 'panel'];

/**
 * Set live stream chat panel
 * @kind action
 * @param {bool} {isGamePanelOpen} - Livestream game panel open or not
 * @param {bool} {isGameOpen} - LiveStream game panel open or not
 * @param {bool} {isChatPanelOpen} - LiveStream Chat keyboard panel open or not
 * @param {bool} {isGiftPanelOpen} - LiveStream Gift keyboard panel open or not
 * @param {bool} {isTriggerPrivatePanelOpen} - LiveStream Trigger private panel open or not
 * @param {bool} {isGiftPanelSwiping} - LiveStream chatroom swiping or not
 * @param {bool} {isTopLeaderboardScrolling} - LiveStream top leaderboard scrolling or not
 * @param {bool} {isAsideExpanded} - LiveStream aside expanded or not
 * @param {bool} {isSuperChatOpen} - Livestream super chat panel open or not
 * @param {bool} {isGiftTooltipVisible} - LiveStream gift tooltip visible or not
 * @return {Promise} Action promise.
 */
const setLiveStreamPanel =
  ({
    isGamePanelOpen,
    isGameOpen,
    isChatPanelOpen,
    isGiftPanelOpen,
    isTriggerPrivatePanelOpen,
    isGiftPanelSwiping,
    isTopLeaderboardScrolling,
    isAsideExpanded,
    isAsideTopPanelExpanded,
    isSuperChatOpen,
    isGiftTooltipVisible,
  }) =>
  async dispatch => {
    let data = {};
    const accordionGroup = {
      isGiftPanelOpen,
      isGamePanelOpen,
      isGameOpen,
      isTriggerPrivatePanelOpen,
    };
    const shouldUpdateAccordion = Object.keys(accordionGroup).some(
      key => accordionGroup[key] != null
    );
    if (shouldUpdateAccordion) {
      let isAccordionOpened = false;
      Object.keys(accordionGroup).forEach(key => {
        if (accordionGroup[key] && isAccordionOpened === false) {
          isAccordionOpened = true;
          data[key] = true;
        } else {
          data[key] = false;
        }
      });
    }
    if (isSuperChatOpen != null) {
      data.isSuperChatOpen = isSuperChatOpen;
    }
    if (isChatPanelOpen != null) {
      data.isChatPanelOpen = isChatPanelOpen;
      if (!isChatPanelOpen) {
        data.isSuperChatOpen = false;
      }
    }
    if (isGiftPanelSwiping != null) {
      data.isGiftPanelSwiping = isGiftPanelSwiping;
    }
    if (isTopLeaderboardScrolling != null) {
      data.isTopLeaderboardScrolling = isTopLeaderboardScrolling;
    }
    if (isAsideExpanded != null) {
      data.isAsideExpanded = isAsideExpanded;
    }
    if (isAsideTopPanelExpanded != null) {
      data.isAsideTopPanelExpanded = isAsideTopPanelExpanded;
    }
    if (isAsideTopPanelExpanded === true) {
      data.isGamePanelOpen = false;
      data.isGameOpen = false;
    }
    if (isGamePanelOpen === true || isGameOpen === true) {
      data.isAsideTopPanelExpanded = false;
    }
    if (isGiftTooltipVisible != null) {
      data.isGiftTooltipVisible = isGiftTooltipVisible;
    }
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { selectPath, data },
    });
  };

export default setLiveStreamPanel;
